// 组件类
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "rs-radio-group",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
})
export class RadioGroupComponent implements OnInit {
  @Input() value;
  @Input() dataSource = [];
  @Input() orientation: 'horizontal' | 'vertical' = 'horizontal';
  @Input() fields = { text: 'text', value: 'value', disabled: 'disabled' }
  @Input() disabled = false;
  @Input() error = false;

  @Output()
  valueChange = new EventEmitter();

  ngOnInit() {
  }
  onChange(event){
    const value = event.value
    this.valueChange.emit(value);
  }
}
